// extracted by mini-css-extract-plugin
module.exports = {"main":"bH_t","feature":"bH_bJ","label":"bH_d","title":"bH_f","pagraph":"bH_bM","imgContainer":"bH_bQ","banner":"bH_l","bannerBlue":"bH_hD"};